var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#E0E0E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 10H14.5C13.675 10 13 10.675 13 11.5V24.5C13 25.325 13.675 26 14.5 26H21.5C22.325 26 23 25.325 23 24.5V11.5C23 10.675 22.325 10 21.5 10ZM18 25C17.7348 25 17.4804 24.8946 17.2929 24.7071C17.1054 24.5196 17 24.2652 17 24C17 23.7348 17.1054 23.4804 17.2929 23.2929C17.4804 23.1054 17.7348 23 18 23C18.2652 23 18.5196 23.1054 18.7071 23.2929C18.8946 23.4804 19 23.7348 19 24C19 24.2652 18.8946 24.5196 18.7071 24.7071C18.5196 24.8946 18.2652 25 18 25ZM22 22H14V12H22V22Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/PhoneIcon.b326fa88d5c116a6ff6ab0ed5fad918e.svg";
export { ForwardRef as ReactComponent };